import { CaretUpDownIcon } from '@phosphor-icons/react';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItemBase,
    DropdownMenuTrigger,
} from '@/components/ui/DropdownMenu';

export interface FeedTitleOption {
    value: string;
    label: string;
}

interface FeedTitleDropdownProps {
    options: FeedTitleOption[];
    onChange: (value: string) => void;
}

export function FeedTitleDropdown({
    options,
    onChange,
}: FeedTitleDropdownProps) {
    const selectedOption = options[0];

    if (options.length <= 1) {
        return (
            <h2 className="text-lg font-medium text-white leading-7">
                {selectedOption?.label}
            </h2>
        );
    }

    return (
        <DropdownMenu modal={false}>
            <DropdownMenuTrigger asChild>
                <button
                    type="button"
                    className="flex items-center gap-1.5 outline-none cursor-pointer"
                >
                    <h2 className="text-lg font-medium text-white leading-7">
                        {selectedOption?.label}
                    </h2>
                    <CaretUpDownIcon className="size-5 text-white shrink-0" />
                </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent
                side="bottom"
                align="start"
                sideOffset={8}
                variant="compact"
            >
                {options.map((option) => (
                    <DropdownMenuItemBase
                        key={option.value}
                        onClick={() => onChange(option.value)}
                    >
                        <span className="text-sm font-medium">
                            {option.label}
                        </span>
                    </DropdownMenuItemBase>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
